import React, { useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'

import { Icon } from 'v2/ui'

type Position = {
    x: number
    y: number
}

type CalendarEventPopupProps = {
    title: string
    date: string
    link: string
    position: Position
    onClose: () => void
    className?: string
}

const CalendarEventPopup: React.FC<CalendarEventPopupProps> = ({
    title,
    date,
    link,
    position,
    onClose,
    className = '',
}) => {
    const history = useHistory()
    const popupRef = useRef<HTMLDivElement>(null)
    const [adjustedPosition, setAdjustedPosition] = React.useState(position)

    useEffect(() => {
        if (popupRef.current) {
            const popup = popupRef.current
            const rect = popup.getBoundingClientRect()
            const viewportWidth = window.innerWidth
            const viewportHeight = window.innerHeight

            let newX = position.x
            let newY = position.y

            // Check horizontal boundaries
            if (position.x - rect.width / 2 < 0) {
                newX = rect.width / 2
            } else if (position.x + rect.width / 2 > viewportWidth) {
                newX = viewportWidth - rect.width / 2
            }

            // Check vertical boundaries
            if (position.y - rect.height / 2 < 0) {
                newY = rect.height / 2
            } else if (position.y + rect.height / 2 > viewportHeight) {
                newY = viewportHeight - rect.height / 2
            }

            setAdjustedPosition({ x: newX, y: newY })
        }
    }, [position])

    const handleDetailsClick = () => {
        if (link) {
            history.push(link)
        }
        onClose()
    }

    const handlePopupClick = (e: React.MouseEvent) => {
        e.stopPropagation()
    }

    return (
        <>
            <div className="calendar-event-popup-overlay" onClick={onClose} role="presentation" />
            <div
                ref={popupRef}
                className={`calendar-event-popup ${className}`}
                style={{
                    left: `${adjustedPosition.x}px`,
                    top: `${adjustedPosition.y}px`,
                    transform: 'translate(-50%, -50%)',
                }}
                role="dialog"
                aria-labelledby="calendar-event-title"
                onClick={handlePopupClick}
            >
                <button
                    className="calendar-event-popup-close"
                    onClick={onClose}
                    aria-label="Close popup"
                >
                    ×
                </button>
                <h3 id="calendar-event-title" className="calendar-event-popup-title">
                    {title}
                </h3>
                <div className="calendar-event-popup-time">
                    <Icon icon="calendar" size="16" />
                    {date}
                </div>
                <button className="calendar-event-popup-details-btn" onClick={handleDetailsClick}>
                    See Details
                </button>
            </div>
        </>
    )
}

export default CalendarEventPopup
